// extracted by mini-css-extract-plugin
module.exports = {"comp":"F_comp__l218r"};